import "./HeadingStyle.css";
export default function Heading({ index, children, id }) {
 
  return (
    <div className="heading-div" id={id} data-aos="fade-left">
      <p className="heading-number">
        0{index}.<span className="heading-block"> {children} </span>
      </p>
    </div>
  );
}
